module.exports = __webpack_public_path__ + "img/9788963700625.690620e4.jpg";